module.exports = __webpack_public_path__ + "static/mvp-9cedbc56a0f15b911f8ad90621a64226.svg";